<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :value="state"
                :options="stateOptions"
                native
                @input="onStateInput"
            />
        </template>

        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import mapFilters from '@/utils/map-filters';

const DEFAULT_STATE = 'default';
const DEFAULT_VALUE = 'none';

export default {
    name: 'box-shadow',
    mixins: [baseOption],

    data() {
        return {
            defaultStyle: 'none',
            displayName: 'Box Shadow',
            tailwindDefinitionProp: 'boxShadow',
            value: DEFAULT_VALUE,

            state: DEFAULT_STATE,
            stateOptions: [
                { text: 'Default', value: 'default' },
                { text: 'On Hover', value: 'hover' },
            ],
        };
    },

    computed: {
        options() {
            return this.themeObjectKeys.map((k, i) => ({
                value: this.themeObjectValues[i],
                text: this.titleCase(k),
            }));
        },

        states() {
            return this.stateOptions.map(opt => opt.value);
        },
    },

    watch: {
        state() {
            this.setValue();
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        setValue() {
            this.value = this.flexClassDefinition.value || DEFAULT_VALUE;
        },

        setState() {
            this.state = this.flexClassDefinition.state || DEFAULT_STATE;
        },

        onInput(valueNew) {
            const flexClassNew = this.addFlexClass({
                value: valueNew,
                state: this.state,
            });

            this.value = valueNew;
            this.onOptionChange(flexClassNew);
        },

        onStateInput(newState) {
            this.state = newState;
        },

        onSelectedElement() {
            this.setState();
            this.setValue();
        },
    },
};
</script>
